import {Component, ViewChild, OnInit, OnDestroy, Inject} from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSidenav, MatDrawer } from '@angular/material/sidenav';
import { CurrentRouteService } from '../currentRoute.service';
import { MainNavService} from "../mainNav.service";
import { MainNavApiService } from "./main-nav-api.service"; //for api calls

import {AgencyIdService,AccountIdService,AccountNameService} from "../account.service";
import {LoggedinServiceBehavior} from "../loggedinbehavior.service";
import {LoggedinService} from "../loggedin.service";
import * as AuthActions from "../login/store/auth.actions";

import { SnackBarService } from '../snackBar.service';

import * as fromApp from '../store/app.reducer';
import {Store} from "@ngrx/store";
import {RoleService} from "../role.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import * as _ from "lodash";
import {MatTableDataSource} from "@angular/material/table";
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {AddAccountDialog, DialogData} from "../accounts/accounts.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AccountInterfaceData} from "../shared/models/account.model";
import {AccountsService} from "../accounts/accounts.service";
import {ModelValidators} from "../validators/validators";

@Component({
  selector: 'app-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.css']
})
export class MainNavComponent implements OnInit, OnDestroy {


  current_route: string;
  currentroute_sub: any;
  agencyid_sub: any;
  accountid_sub: any;
  accuntname_sub: any;
  role_sub: any;
  mainnav_sub: any;
  loggedin_sub: any;
  account_id: string;
  agency_id: string;
  account_name: string;
  campaign_id: string = 'wow'
  role:string;
  notification_count: number = 0;

  sidebar_closed: boolean = false;
  navigate_back_to_account: boolean = false;

  is_default_settings: boolean = false;
  is_user_settings: boolean = false;
  is_agency_route: boolean = true;
  is_account_route: boolean = true;
  is_login_route: boolean  = true;
  is_show_menu: boolean = false;
  sb_sub: any;

  @ViewChild('drawer', { static: true }) public drawer!: MatDrawer;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  constructor(private breakpointObserver: BreakpointObserver,
              private router: Router,
              private route: ActivatedRoute,
              private currentrouteService: CurrentRouteService,
              private roleService: RoleService,
              private agencyidService: AgencyIdService,
              private accountidService: AccountIdService,
              private accountnameService: AccountNameService,
              private mainnavService: MainNavService,
              private mainnavapiService: MainNavApiService,
              public dialog: MatDialog,
              private snackbarService: SnackBarService,
              public snackBar: MatSnackBar,
              private loggedinServiceBehavior: LoggedinServiceBehavior,
              private loggedinService: LoggedinService,
              private store: Store<fromApp.AppState>) {
  } //end constructor()

  openSnackBar(message: string, action: string) {
    console.log('VVVVVVVVV')
    let snackBarRef = this.snackBar.open(message, action, {
      duration: 5000,
    });
    snackBarRef.afterDismissed().subscribe(() => {
    });
    snackBarRef.onAction().subscribe(() => {
      //this._apiService.refreshToken()
    });
    snackBarRef.dismiss();
  } //end openSnackBar

  ngOnInit(): void {

    this.sb_sub = this.snackbarService.snackbarAnnounced$.subscribe(
      message => {
        console.log('SNACK BAR MESSAGE dude!!!!',message)
        this.openSnackBar(message,'');
      }); //end role_sub


    //handle reloading of page
    this.role = localStorage.getItem('role');
    if (this.role) {
      this.roleService.announceRole(this.role)
    }


    // this.loggedinService.loggedinAnnounced$.subscribe(
    //   loggedin => {
    //     console.log('from nav reg loggedin: ' + loggedin);
    //   }
    // );
    // this.loggedin_sub = this.loggedinServiceBehavior.loggedinAnnouncedBehavior.subscribe(
    //   (loggedin: boolean) => {
    //     console.log('from nav behave loggedin: ' + loggedin);
    //   }
    // );

    let role_sub = this.roleService.roleAnnounced$.subscribe(
      role => {
        this.role = role;
        console.log('ROLE',this.role);
      }
    ); //end role_sub

    let accountid_sub = this.accountidService.accountidAnnounced.subscribe(
      accountid => {
        this.account_id = accountid;
        console.log('ACCOUNT ID!!!!!!!!!!!!!',this.account_id);
        if (this.account_id){
          this.loadNotificatonsAccount(this.account_id)
        }

      }
    );
    let agencyid_sub = this.agencyidService.agencyidAnnounced.subscribe(
      agencyid => {
        console.log('agencyid!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!#########',agencyid);
        this.agency_id = agencyid //(agencyid != null);
        if (agencyid != null) {
          //this.loadNotificatons(agencyid)
        }

      }
    );
    let accountname_sub = this.accountnameService.accountnameAnnounced.subscribe(
      accountname => {
        this.account_name =  accountname //(accountname != null);
      }
    );
    //TODO NEED TO FINDOUT WITH ON RELOAD THE BELOW WORKS BUT THE ABOVE DOES NOT BUT ONLY WORKS ON INTIAL
    //ONLY ONE SHOULD WORK ALL OF THE TIME
    this.account_name = localStorage.getItem('account_name')

    this.route.params.subscribe(parms => {
      this.agency_id = parms['agency_id']
      // if (this.agency_id  != null) {
      //   this.loadNotificatons(this.agency_id)
      // }
      console.log('report campaign performance!!!!!!!!!!!!!!!', this.agency_id)
    });


    //We are controlling the sidenav here weather to be forced closed or not based on the current route
    this.currentroute_sub = this.currentrouteService.currentrouteAnnounced$.subscribe(
      current_route => {
        this.current_route = current_route;
        this.stateSideNav(current_route)
        console.log('current_route: ' + current_route);
      }); //end role_sub

    //We have this service becuase on reload we loose browser state
    //Alternative is ngrx store but lets not complicate things for now
    //We are setting the view of the sidenav here to show user preferences and
    //setting a flag for teh view to know if we should navigate back to the account or campaigns
    this.mainnav_sub = this.mainnavService.mainnavAnnounced$.subscribe(
      mainnav => {
        if (mainnav['is_user_settings']==='true' && mainnav['is_account_route']==='false'){
          this.is_user_settings = true;
          this.sidebar_closed = false;
          this.navigate_back_to_account = false
        } else if (mainnav['is_user_settings']==='true' && mainnav['is_account_route']==='true'){
          this.sidebar_closed = false;
          this.is_user_settings = true;
          this.navigate_back_to_account = true;
        } else {}
      }); //end mainnav_sub

  } //end ngOnInit()

  toggle(){
    if (this.drawer.opened){
      this.drawer.close()
    } else {
      this.drawer.open()
    }
  } //end toggle()

  //WE NEED TO ACCOUNT FOR EVERY ROUTE E.G. CAMPAIGNS, ACCOUNT ETC BECUASE A USER CAN ENTER A BOGUS ROUTE I THINK
  stateSideNav(current_route){

    console.log('-------->','current_route:',current_route,'role',this.role)
    if(current_route.startsWith('/login')){
      this.is_default_settings = false;
      this.is_user_settings = false
      this.is_login_route = true;
      this.is_agency_route = false;
      this.is_account_route = false;
      this.is_show_menu = false;
      this.account_name = null;
      this.drawer.close();
    } else if (current_route.startsWith('/integrations-redirect')) {

      console.log('WTFFF',this.drawer.opened)
      this.is_default_settings = false;
      this.is_user_settings = false
      this.is_login_route = true;
      this.is_agency_route = false;
      this.is_account_route = false;
      this.is_show_menu = false;
      this.account_name = null;
      this.drawer.close();
    } else if (current_route.startsWith('/forgot')) {
      this.is_default_settings = false;
      this.is_user_settings = false
      this.is_login_route = true;
      this.is_agency_route = false;
      this.is_account_route = false;
      this.is_show_menu = false;
      this.account_name = null;
      this.drawer.close();
    } else if (current_route.startsWith('/agencys')) {
      this.is_default_settings = false;
      this.is_user_settings = false
      this.is_login_route = false;
      this.is_agency_route = true;
      this.is_account_route = false;
      this.is_show_menu = false;
      this.account_name = null;
      this.drawer.close();
      console.log("case accounts")
    } else if (current_route.startsWith('/accounts') && this.role === 'admin') {
      this.is_default_settings = false;
      this.is_user_settings = false
      this.is_login_route = false;
      this.is_agency_route = false;
      this.is_account_route = true;
      this.is_show_menu = false;
      this.drawer.close();
      console.log("case accounts admin")
    } else if (current_route.startsWith('/accounts') && this.role === 'superadmin') {
      this.is_default_settings = false;
      this.is_user_settings = false
      this.is_login_route = false;
      this.is_agency_route = false;
      this.is_account_route = true;
      this.is_show_menu = true;
      this.drawer.open();
      console.log("case accounts superadmin")
    } else if (current_route.startsWith('/dashboard')) {
      this.is_default_settings = true;
      this.is_user_settings = false
      this.is_login_route = false;
      this.is_agency_route = false;
      this.is_account_route = false;
      this.is_show_menu = true;
      this.drawer.open(); //on mobile make sure the sidnav is open so user can see options
      console.log("case dashboard")
    } else if (current_route.startsWith('/user')){
      this.is_default_settings = false;
      this.is_user_settings = true;
      this.is_login_route = false;
      this.is_agency_route = false;
      this.is_account_route = false;
      this.is_show_menu = true;
      this.drawer.open();  //on mobile make sure the sidnav is open so user can see options
      console.log("case user")
    } else {
      this.is_default_settings = true;
      this.is_user_settings = false
      this.is_login_route = false;
      this.is_agency_route = false;
      this.is_account_route = false;
      this.is_show_menu = true;
      //this.drawer.open();  //use users default choice for switching
      console.log("default")
    } //end else
    //this.drawer.toggle();
    //console.log(this.drawer.opened)
  } //end stateSideNav()

  ngOnDestroy(): void {
    //this.currentroute_sub.unsubscribe();
    //this.mainnav_sub.unsubscribe()
    //this.loggedin_sub.unsubscribe()
    this.loggedinServiceBehavior.announceLoggedin(false);
    this.loggedinService.announceLoggedin(false)


  }

  userSettings(){
    let is_account_route = 'false';
    if (this.current_route.indexOf('accounts')>=0){
      is_account_route = 'true';
    }
    this.is_user_settings = true;
    this.router.navigate(['user','preferences'], { queryParams: { is_user_settings: 'true', is_account_route: is_account_route } })
  }

  backToAccounts(){
    /*
    We can load user settings from campaigns or accounts
    When we go back need to know where we came from
    */
    this.is_user_settings = false;
    if (this.navigate_back_to_account) {
      this.router.navigate(['accounts',this.agency_id])
    } else {
      this.router.navigate(['dashboard',this.agency_id,this.account_id])
    }
  } //end backToAccounts()

  logout() {
    console.log('logging out in nav')
    this.currentrouteService.announceCurrentRoute('login');
    this.router.navigate(['login']);
    this.store.dispatch(new AuthActions.Logout())

    //this.loggedinService.announceLoggedin(false);
    //this.loggedinServiceBehavior.announceLoggedin(false);
    //this.agencyServiceBehavior.announceAgency(null);
    //this.accountServiceBehavior.announceAccount(null);
    // //window.location.href = environment['login'] //signin
    // this.currentrouteService.announceCurrentRoute('login');
    // this.router.navigate(['/login']);
  } //end logout()

  notification_data:any = [];
  loadNotificatons(agency_id){
    console.log('%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%')
    console.log('%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%')
    console.log('%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%')
    let endpoint = `notifications/agency/${agency_id}`;
    let fu = this.mainnavapiService.get(endpoint).subscribe(x => {
      console.log('notification data',x)
      this.notification_count = 0;
      this.notification_data = [];
      console.log('NOTOFICATION COUNT',this.notification_count)
      if (_.isEmpty(x['body'])) {
        console.log('no notification data')
        this.notification_count = 0;
      } else {
        console.log('proccess notification data')
        console.log('wtf',  x['body'])
        //this.notification_data = x['body'];
        //this.notification_count = this.notification_data.length
      }

    }, error => {
      console.log('ERROR',error)
    }); //end apiService


  } //end loadNotificatons()

  loadNotificatonsAccount(account_id){
    this.notification_count = 0;
    this.notification_data = [];
    let endpoint = `notifications/account/${account_id}`;
    let fu = this.mainnavapiService.get(endpoint).subscribe(x => {
      this.notification_data = x['body'];
      console.log('from main-nav notification data',this.notification_data)
      this.notification_count = 0;
      this.notification_data = [];
      console.log('NOTOFICATION COUNT',this.notification_count)
      if (_.isEmpty(x['body'])) {
        console.log('no notification data')
        this.notification_count = 0;
      } else {
        console.log('proccess notification data')
        this.notification_data = x['body'];
        this.notification_count = this.notification_data.length
      }

    }, error => {
      console.log('ERROR',error)
    }); //end apiService


  } //end loadNotificatons()

  onClickNotifications(){
    //this.is_edit = is_edit;
    const config = new MatDialogConfig();
    config.disableClose = true;

    // let idx = null;
    // let account_object = null;
    // if (account_id != null) {
    //   account_object = this.accounts_hash[account_id];
    //   idx = this.account_idx_hash[account_id];
    // }

    let agency_id = localStorage.getItem('agency_id');

    const dialogRef = this.dialog.open(NotificationsDialog, {
      width: '500px',
      //height: '300px',
      data: {account_name: this.account_name}
    });
    dialogRef.componentInstance.agency_id = agency_id;
    dialogRef.componentInstance.notification_data = this.notification_data;
    //dialogRef.componentInstance.is_edit = is_edit;
    //dialogRef.componentInstance.account_object = account_object
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'cancel') {
        console.log('WE CANCLED!!!!!!!!!')
      } else {
        console.log('WE BETTER RELOAD')
        this.loadNotificatons(agency_id) //reload table
      }
    });//end dialogRef.afterClosed()


  } // end notifications modal

} //end class





/*---------------------------------------------
Dialog for notifications
---------------------------------------------*/

@Component({
  selector: 'notifications-dialog',
  templateUrl: 'notifications-dialog.html',
  styleUrls: ['./main-nav.component.css']
})
export class NotificationsDialog implements OnInit {

  agency_id: string;
  notification_data: any = [];


  constructor(
    private mainnavapiService: MainNavApiService,
    public dialogRef: MatDialogRef<NotificationsDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
  } //end constructor

  ngOnInit(): void {
  }//end ngOnInit


  deleteRow(notification_id, idx){
    console.log(notification_id, idx)

    //delete the notificaton from list
    this.notification_data.splice(idx,1);
    //make an api call to delete notificaton from database
    let endpoint = `notifications/${notification_id}`;
    let fu = this.mainnavapiService.delete(endpoint).subscribe(x => {
      console.log('uber',x)
    }, error => {
      console.log('ERROR',error)
    }); //end apiService
    //On close notifications are reloaded


  } //end deleteRow


} //end NotificationsDialog
